import inDOM from 'dom-helpers/util/inDOM';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import round from '../helpers/round';
import theme from '../styles/theme';

const supportsLineClamp = inDOM && ('webkitLineClamp' in global.document.documentElement.style);

const isTransparent = color => /(?:rgba\(\s*(?:\d+,\s*){3}0\s*\)|transparent)/.test(color);
const getClosestBackgroundColor = el => {
  if (!el) {
    return theme.colors.white;
  }
  const bgColor = global.window.getComputedStyle(el).backgroundColor;
  if (bgColor && !isTransparent(bgColor)) {
    return bgColor;
  }
  return getClosestBackgroundColor(el.parentNode);
};

class LineClamp extends PureComponent {
  setRef = el => {
    if (el) {
      this.el = el;
      if (supportsLineClamp) {
        this.initializeLineClamp();
      } else {
        this.initializeFallback();
      }
    }
  };

  initializeFallback() {
    const { el } = this;
    const { classes, lines } = this.props;
    const lineHeight = parseInt(global.window.getComputedStyle(el).lineHeight, 10);
    const maxHeight = round(lines * lineHeight);
    el.style.maxHeight = `${maxHeight}px`;

    const fadeOut = global.document.createElement('span');
    fadeOut.innerHTML = '\xa0';
    fadeOut.className = classes.fadeOut;
    const bgColor = getClosestBackgroundColor(el);
    fadeOut.style.backgroundImage = `linear-gradient(to right, transparent, ${bgColor} 50%)`;
    el.appendChild(fadeOut);
  }

  initializeLineClamp() {
    const { el } = this;
    const { lines } = this.props;
    el.style.display = '-webkit-box';
    el.style.webkitBoxOrient = 'vertical';
    el.style.webkitLineClamp = lines;
  }

  render() {
    const { children, classes } = this.props;
    return React.cloneElement(children, {
      className: cn(children.props.className, classes.lineClamp),
      ref: this.setRef,
    });
  }
}

LineClamp.propTypes = {
  children: PropTypes.element.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  lines: PropTypes.number,
};

LineClamp.defaultProps = {
  lines: 2,
};

export default injectSheet({
  lineClamp: {
    overflow: 'hidden',
    position: 'relative',
  },
  fadeOut: {
    display: 'block',
    position: 'absolute',
    right: 0,
    textAlign: 'right',
    bottom: 0,
    width: '40%',
  },
})(LineClamp);
